module.exports = __webpack_public_path__ + "static/media/yellowLines.547bf243.svg";